"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var plot_1 = tslib_1.__importDefault(require("../../base/plot"));
var layer_1 = tslib_1.__importDefault(require("./layer"));
var PercentageStackBar = /** @class */ (function (_super) {
    tslib_1.__extends(PercentageStackBar, _super);
    function PercentageStackBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PercentageStackBar.prototype.createLayers = function (props) {
        var layerProps = _.deepMix({}, props);
        layerProps.type = 'percentageStackBar';
        _super.prototype.createLayers.call(this, layerProps);
    };
    PercentageStackBar.getDefaultOptions = layer_1.default.getDefaultOptions;
    return PercentageStackBar;
}(plot_1.default));
exports.default = PercentageStackBar;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/percentage-stack-bar/index.js
// module id = 941
// module chunks = 37